import {View} from 'MWC';
import tpl from './templates/interactive';

export default class extends View {
    template = tpl;

    static displayName = 'AlwaysTouchOffers';
}
